import { selectFeesResponse } from '../../redux-state/selectors';
import { useSelector } from 'react-redux';
import { buildFeeItems, splitFeeColumns } from '../utility/feeItems';

function OutputRightSide({ downloadAble }) {
  const response = useSelector(selectFeesResponse);

  // Flattening, alphabetical ordering and the two-column split all live in
  // utility/feeItems so this screen, the online PDF (generateFeesReport) and
  // the bot's summary PDF cannot drift apart. See the header comment there for
  // why the ordering is alphabetical rather than ATC's <FeeDetails> order.
  const [leftItems, rightItems] = splitFeeColumns(buildFeeItems(response));

  const renderFeeColumn = (items, columnKey) => (
    <div key={columnKey} className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
      {items.map(([label, amount]) => (
        <div key={label} className='flex flex-row justify-between gap-4 items-start'>
          <div>
            {label}
          </div>
          <div className='font-medium text-right break-words min-w-0'>
            {amount}
          </div>
        </div>
      ))}
    </div>
  );

  const dynamicFields = [renderFeeColumn(leftItems, 'left'), renderFeeColumn(rightItems, 'right')];

  function replaceLinksWithTextAndHref(html) {
    return html.replace(/<a[^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/g, '$2 ($1)');
  }

  return (
    <div className='flex flex-col w-[100%]'>
      <div className='flex flex-col gap-4 w-[100%]'>
        <div className='flex flex-row justify-between mb-4 items-center'>
          <div className='text-gray-700 font-bold'>
            Fees Output
          </div>
        </div>
      </div>

      <div className='bg-white p-6 rounded-xl text-sm mb-4 mt-4 border border-gray-300'>
        <div className='text-gray-700 mb-3 font-bold'>
          Fee Output
        </div>

        <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-8 mb-2'>
          {dynamicFields}
        </div>
      </div>

      {response["Notes"] && response["Notes"] !== "" &&
        <div className='bg-white p-6 rounded-xl text-sm border border-gray-300'>
          <div className='mb-2 text-gray-700 font-bold'>
            Notes
          </div>
          <ul className="list-disc pl-6 space-y-2 text-gray-600 text-xs">
            {response["Notes"].split('|').map((note, key) => (
              <li
                key={key}
                className='sanitizedHtml'
                dangerouslySetInnerHTML={{
                  __html: downloadAble
                    ? replaceLinksWithTextAndHref(note)
                    : note.replaceAll('<a ', '<a target="_blank" ')
                }}
              />
            ))}
          </ul>
        </div>
        }
    </div>
  )
}

export default OutputRightSide;